import React from "react";
import { Link } from "react-router-dom";
import { IoIosMenu } from "react-icons/io";
import LanguageWidget from "./sub-components/LanguageWidget";
import triggerOffCanvas from "../../utils/triggerOffCanvas";

const HeaderBtn = () => {
  return (
    <div className="header-btn-wrapper">
      <ul className="accounts d-none d-lg-flex">
        <li>
          <LanguageWidget />
        </li>

        <li className="active ml-5">
          <Link to={process.env.PUBLIC_URL + "/login-register"}>
            Login/Register
          </Link>
        </li>
      </ul>
      <div className="row navbar__mobile-row mobile-button-wrapper d-lg-none text-right">
        <div className="col-6 navbar__mobile-btn-div">
          <Link
            className="navbar__mobile_link"
            to={process.env.PUBLIC_URL + "/login-register"}
          >
            Login/Register
          </Link>
        </div>
        <div className="col-6 navbar__mobile-icon">
          <button
            className="mobile-aside-button"
            onClick={() => triggerOffCanvas("#offcanvas-mobile-menu")}
          >
            <IoIosMenu />
          </button>
        </div>
      </div>
    </div>
  );
};

export default HeaderBtn;
